<template>

  <div class="page-data-list">
    	
    	
    <b-card no-body>
      <b-table
        :items="csvDatas"
        show-empty
        :empty-text="$t('No matching records found')"
        class="position-relative modal-height"
        :fields="csvColumns"
        fixed
        responsive
      >
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: setCsvTableColWidth(field.key)+'px' }"
          >
        </template>
      
        <template #cell(dir)="data">
          {{ data.item.dir==='1'?'Tx':'Rx' }}
        </template>
        
      </b-table>
    
    
    </b-card>	  
	  
  </div>	
  
</template>

<script>
import {
  BCard, BCardBody, BTable
} from 'bootstrap-vue'
import { getCsvData } from '@/api/data'

export default {
  components: { 
    BCard,
	BCardBody,
	BTable,
  },
  data() {
    return {			  
	  csvColumns: [
		{ key: 'no', label: 'No.' },
		{ key: 'timeStamp', label: 'TimeStamp' },
		{ key: 'deviceID', label: 'Device ID' },
		{ key: 'dir', label: 'Dir.' },
		{ key: 'address', label: 'Address' },
		{ key: 'rawData', label: 'Raw Data' },
      ],
	  //csv数据
	  csvDatas:[],
    }
  },
  created() {
	  this.getCsvData(this.$route.params.name);
  },
  methods: { 
	//获取csv数据
	getCsvData(taskId){
      getCsvData({taskId}).then(response => { 
	    this.csvDatas = response.data
      })
    }, 
	
	//弹窗表格宽度
	setCsvTableColWidth(col){
	  if(col=='no' || col=='dir'){
		return 50
	  }
	  else if(col=='rawData'){
	    return 240
	  }
	  else if(col=='timeStamp'){
	    return 100
	  }
	  else{
		return 100 
	  }
	}
  },
}
</script>
<style>
	.table thead th, .table tfoot th {
	  text-transform: none !important;
	}
</style>
